import cx from 'classnames';
import Image from 'common/components/Image';
import { StyledFlex } from 'common/styles/common.styles';
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import React, { PropsWithChildren } from 'react';
import { StyledLinkButton } from './linkButton.style';

type Props = {
  to: string;
  disabled?: boolean;
  id?: string;
  className?: string;
};

export const ExternalLinkButton: React.FC<Props & PropsWithChildren> = (
  props
) => {
  const iconClassName = props.className?.includes('icon-new-window-white')
    ? 'icon-new-window-white'
    : 'icon-new-window';
  const btnClassName = props.className?.replace('icon-new-window-white', '');
  const btnHeight = props.className?.includes(' h-') ? '' : 'h-8';
  return (
    <StyledLinkButton>
      <OutboundLink target="_blank" href={props.to}>
        <button
          className={cx(
            `primary-button-bg-color ${btnClassName} ${btnHeight}`,
            props.disabled &&
              `primary-button-disabled-bg-color ${btnClassName} ${btnHeight}`
          )}
          type="button"
          id={props.id}
        >
          <StyledFlex justifyContent="center">
            <span className="primary-button-color">{props.children}</span>
            <Image
              key="second in pair"
              className={iconClassName}
              alt="new window icon"
              marginLeft="5px"
            />
          </StyledFlex>
        </button>
      </OutboundLink>
    </StyledLinkButton>
  );
};
